export default "__VITE_ASSET__DIxQz2OG__"